import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["radio", "checkbox", "drawer"];

  connect() {
    this.sync();
  }

  sync() {
    const selectedRadio = this.radioTargets.find((radio) => radio.checked);
    const selectedOutputType = selectedRadio ? selectedRadio.value : "";

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checkbox.dataset.structuredOutputTypeValue === selectedOutputType;
    });

    this.drawerTargets.forEach((drawer) => {
      if (drawer.dataset.structuredOutputTypeValue === selectedOutputType) {
        drawer.open = true;
      }
    });
  }

  stopSummaryToggle(event) {
    event.stopPropagation();
  }
}
